<template>
<div class="chapter">
<div class="inner_page">
<p class="colophon"><span>Europa Editions<br/>
  116 East 16th Street<br/>
  New York, N.Y. 10003<br/>
  info@europaeditions.com<br/>
  www.europaeditions.com<br/>
<br/>
  The author thanks Marcella D.R. Catignani and Valeria Pollino.<br/>
<br/>
  The translator thanks Clementina Liuzzi, Toby Olson and, for the right sort of inspiration, Andrew Vachss.<br/>
<br/>
  This book is a work of fiction. Any references to historical events, real people, or real locales are used fictitiously.<br/>
<br/>
  Copyright © 2000 by Edizioni E/O<br/>
  First publication 2006 by Europa Editions<br/>
<br/>
  Translation by Lawrence Venuti<br/> 
  Original Title: <i>Arrivederci amore, ciao</i><br/>
<br/>
  All rights reserved, including the right of reproduction in whole or in part in any form.<br/>
<br/>
  Cover Art by Emanuele Ragnisco<br/>
  www.mekkanografici.com<br/>
<br/>
  ISBN 9781609450250</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// colophoneuropa.vue?8e67b5aa